import api from '../api'
import includes from 'lodash/includes'
import {fetchUser,fetchUserSignInMethods} from './user'
import {fetchFolders} from './library/folders'
import {fetchFoldersPreview} from './library/folders'
import {fetchSets} from './library/sets'
import {fetchSetsPreview} from './library/sets'
import {fetchQuestions} from './library/questions'
import {fetchQuestionsPreview} from './library/questions'
import {fetchSetPolls,fetchQuestionPolls} from './polls'
import {fetchRecentActivities} from './recentActivities'
import {fetchMeta} from './meta'
import {fetchSectionControl} from './sectionControl'
import {fetchControl} from './control'
import {fetchArchivedSections} from './sections'
import {fetchService} from './service'
import {fetchBilling} from './billing'
import {loadSetEditorData} from './loadSetEditorData'
import {loadQuestionEditorData} from './loadQuestionEditorData'
import {syncClock} from './syncClock'
import {fetchGeoInfo} from './geoInfo'
import {fetchRepos,fetchAPublishedRepoByShortId} from './repos'
import {fetchSearchKey} from './searchKey'
import {fetchMobileInfo} from './mobileInfo'
import {fetchReviewsForUser} from './reviews'
import {fetchSubmissions} from './submissions'
import {fetchIntegrations} from './integrations'
import {sectionPresencePusherSetup} from '../utils/pusher/sectionPresencePusherSetup'
import discoverRepoIds from '../discoverRepoIds.js'


const biologyRepoShortIds=discoverRepoIds.biologyRepoShortIds
// ALL Early Math
const mathsRepoShortIds=discoverRepoIds.mathsRepoShortIds
	
const keyTextsRepoShortIds=discoverRepoIds.keyTextsRepoShortIds




export function loadInitialData(userId) {

	if( includes(window.location.pathname,'seteditor')){
		const res=window.location.pathname.match('/seteditor/(.*)')
		let setId
		if(res && res.length===2){
			setId=res[1]
		}

		return loadSetEditorData(setId,userId)		
	}	
	else if( includes(window.location.pathname,'editor')){
		const res=window.location.pathname.match('/editor/(.*)')
		let questionId
		if(res && res.length===2){
			questionId=res[1]
		}
		return loadQuestionEditorData(questionId,userId)		
	}
	
	else{
	return (dispatch) => {
		api.batchedFetch('/sections?archived=false&populated=true')
		.then((response) => {
			dispatch({ type: 'FETCH_All_SECTIONS_SUCCESS', response })
			response.forEach(section => {
				dispatch(fetchSectionControl(section.id))
				if(section.studentAccess.enabled){
					sectionPresencePusherSetup(section.id)
				}
			})

     	})
     	.catch(err => {
	    		 })


     	const lastViewedDiscover = JSON.parse(localStorage.getItem('lastViewedDiscover'))

		if(lastViewedDiscover && lastViewedDiscover.subject && !includes(window.location.pathname,'discover')){
			const {subject,subSubject,page}=lastViewedDiscover
			if(subject==='earlyMath'){
				mathsRepoShortIds.map((shortId)=>{
				dispatch(fetchAPublishedRepoByShortId(shortId))
					.catch((error)=>{
					
				})
			})}

			else if(subject==='biology'){
				biologyRepoShortIds.map((shortId)=>{
				dispatch(fetchAPublishedRepoByShortId(shortId))
					.catch((error)=>{
					
				})
			})}
			else if(subject==='keyTexts'){
				keyTextsRepoShortIds.map((shortId)=>{
				dispatch(fetchAPublishedRepoByShortId(shortId))
					.catch((error)=>{
					
				})
			})}

			
		}




     	 	dispatch(fetchSearchKey())
     	 	dispatch(fetchReviewsForUser())
     		dispatch(fetchFolders())
     		dispatch(fetchRepos())
			dispatch(fetchSets())
			dispatch(fetchSetsPreview())
			dispatch(fetchQuestionsPreview())
			dispatch(fetchFoldersPreview())
			
	
			dispatch(fetchQuestions())

     		dispatch(fetchService())
     		
     		dispatch(fetchIntegrations())

			dispatch(fetchUser(userId))
			dispatch(fetchUserSignInMethods(userId))
			dispatch(fetchRecentActivities())
			dispatch(fetchSetPolls())
			dispatch(fetchQuestionPolls())
			dispatch(fetchMeta())
			dispatch(fetchMobileInfo())
			dispatch(fetchControl())
			dispatch(fetchArchivedSections())
			dispatch(fetchBilling())
			dispatch(fetchGeoInfo())
			dispatch(fetchSubmissions())
			setTimeout(function() { //Start the timer
				dispatch(syncClock())
			},	5000)
	}
}
}

